import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-3 mb-4 bg-white shadow-sm" }
const _hoisted_2 = { class: "card-header bg-light-subtle d-flex justify-content-between align-items-center py-3 px-4" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2" }
const _hoisted_4 = { class: "mb-0 fs-15 fw-bold text-dark d-flex align-items-center gap-2" }
const _hoisted_5 = {
  key: 0,
  class: "badge bg-primary-subtle text-primary border border-primary"
}
const _hoisted_6 = {
  key: 0,
  class: "badge bg-success-subtle text-success fs-12 px-3 py-2"
}
const _hoisted_7 = {
  key: 1,
  class: "badge bg-warning-subtle text-warning fs-12 px-3 py-2"
}
const _hoisted_8 = { class: "card-body p-4" }
const _hoisted_9 = {
  key: 0,
  class: "mb-4 p-3 rounded-3 bg-light border border-light-subtle"
}
const _hoisted_10 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3" }
const _hoisted_11 = { class: "fw-bold text-primary mb-0" }
const _hoisted_12 = { class: "d-flex gap-2" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "row g-2 fs-13" }
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = { class: "fw-bold text-dark ms-1" }
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = { class: "fw-semibold text-dark ms-1" }
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = { class: "badge ms-1 bg-success" }
const _hoisted_24 = { class: "col-md-3" }
const _hoisted_25 = { class: "fw-semibold text-dark ms-1" }
const _hoisted_26 = { class: "row mb-3" }
const _hoisted_27 = { class: "col-md-4 mb-2" }
const _hoisted_28 = { class: "col-md-4 mb-2" }
const _hoisted_29 = { class: "col-md-4 mb-2" }
const _hoisted_30 = { class: "p-3 bg-light rounded-2 mb-3 border" }
const _hoisted_31 = { class: "table-responsive mb-3" }
const _hoisted_32 = { class: "table table-sm table-bordered align-middle fs-12 mb-0 bg-white" }
const _hoisted_33 = { class: "table-light" }
const _hoisted_34 = { class: "p-3 bg-light rounded-2 mb-3 border" }
const _hoisted_35 = { class: "row g-2 fs-12" }
const _hoisted_36 = { class: "col-md-4" }
const _hoisted_37 = { class: "form-check" }
const _hoisted_38 = { class: "col-md-4" }
const _hoisted_39 = { class: "form-check" }
const _hoisted_40 = { class: "col-md-4" }
const _hoisted_41 = { class: "form-check" }
const _hoisted_42 = { class: "col-md-4" }
const _hoisted_43 = { class: "form-check" }
const _hoisted_44 = { class: "col-md-4" }
const _hoisted_45 = { class: "form-check" }
const _hoisted_46 = { class: "col-md-4" }
const _hoisted_47 = { class: "form-check" }
const _hoisted_48 = { class: "p-3 bg-light-subtle rounded-2 mb-3 border" }
const _hoisted_49 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_50 = {
  key: 0,
  class: "text-center py-3 text-muted fs-12 bg-white rounded border mb-2"
}
const _hoisted_51 = { class: "col-md-3" }
const _hoisted_52 = ["onUpdate:modelValue", "onInput"]
const _hoisted_53 = { class: "col-md-2" }
const _hoisted_54 = ["onUpdate:modelValue"]
const _hoisted_55 = { class: "col-md-3" }
const _hoisted_56 = ["onUpdate:modelValue", "onChange"]
const _hoisted_57 = { class: "col-md-3" }
const _hoisted_58 = ["onUpdate:modelValue", "onInput"]
const _hoisted_59 = { class: "col-md-1 text-center pt-3" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "row mb-3" }
const _hoisted_62 = { class: "col-md-4 mb-2" }
const _hoisted_63 = { class: "col-md-4 mb-2" }
const _hoisted_64 = { class: "col-md-4 mb-2" }
const _hoisted_65 = { class: "col-md-4 mb-2" }
const _hoisted_66 = { class: "col-md-8 mb-2" }
const _hoisted_67 = { class: "col-12 mt-2" }
const _hoisted_68 = { class: "card bg-light-subtle border p-3 rounded-3 mb-2" }
const _hoisted_69 = { class: "row g-3" }
const _hoisted_70 = { class: "col-md-4" }
const _hoisted_71 = { class: "col-md-4" }
const _hoisted_72 = ["value"]
const _hoisted_73 = { class: "col-md-4" }
const _hoisted_74 = {
  key: 0,
  class: "col-12 mt-1"
}
const _hoisted_75 = { class: "d-flex align-items-center gap-3 p-2 bg-white rounded border" }
const _hoisted_76 = ["src"]
const _hoisted_77 = { class: "d-flex justify-content-end gap-2 mt-4" }
const _hoisted_78 = ["disabled"]
const _hoisted_79 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[36] || (_cache[36] = _createElementVNode("span", { class: "material-symbols-outlined text-primary fs-22" }, "spellcheck", -1)),
        _createElementVNode("h5", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_ctx.order?.service_type === 'AI_CHECK' ? 'Protokol Penyuntingan Tata Bahasa (SOP RBN/SOP-RC/GRM/001)' : 'Protokol Penyuntingan & Parafrase (SOP RBN/SOP-RC/GRM/001)'), 1),
          (_ctx.order?.service_type === 'AI_CHECK')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Bagian Layanan Drillbit "))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.protocol)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.protocol.protocol_number), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_7, " Belum Dibuat "))
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.protocol)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _cache[37] || (_cache[37] = _createElementVNode("div", { class: "text-muted fs-12" }, "Nomor Protokol Resmi", -1)),
                _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.protocol.protocol_number), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generatePdf && _ctx.generatePdf(...args))),
                  disabled: _ctx.generatingPdf,
                  class: "btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                }, [
                  (_ctx.generatingPdf)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                    : _createCommentVNode("", true),
                  _cache[38] || (_cache[38] = _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "picture_as_pdf", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.generatingPdf ? 'Membuat PDF...' : 'Regenerate PDF Protokol'), 1)
                ], 8, _hoisted_13),
                (_ctx.protocol?.generated_pdf || _ctx.order.generated_protocol_pdf)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.getFileUrl(_ctx.protocol?.generated_pdf || _ctx.order.generated_protocol_pdf),
                      target: "_blank",
                      class: "btn btn-sm btn-success d-flex align-items-center gap-1"
                    }, _cache[39] || (_cache[39] = [
                      _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "download", -1),
                      _createElementVNode("span", null, "Unduh Dokumen Resmi A4", -1)
                    ]), 8, _hoisted_15))
                  : _createCommentVNode("", true),
                (_ctx.protocol.verification?.verification_code)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: _ctx.getVerificationUrl(_ctx.protocol.verification.verification_code),
                      target: "_blank",
                      class: "btn btn-sm btn-info text-white d-flex align-items-center gap-1"
                    }, _cache[40] || (_cache[40] = [
                      _createElementVNode("span", { class: "material-symbols-outlined fs-16" }, "verified", -1),
                      _createElementVNode("span", null, "Cek Verifikasi Publik", -1)
                    ]), 8, _hoisted_16))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[41] || (_cache[41] = _createElementVNode("span", { class: "text-muted" }, "Skor Kinerja:", -1)),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.protocol.score_before || '-') + " → " + _toDisplayString(_ctx.protocol.score_after || '-') + "/100", 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[42] || (_cache[42] = _createElementVNode("span", { class: "text-muted" }, "Level Parafrase:", -1)),
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.protocol.paraphrase_level), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[43] || (_cache[43] = _createElementVNode("span", { class: "text-muted" }, "Keputusan:", -1)),
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.protocol.status_decision), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _cache[44] || (_cache[44] = _createElementVNode("span", { class: "text-muted" }, "Editor:", -1)),
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.protocol.editor_name), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _cache[35] || (_cache[35] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveProtocol && _ctx.saveProtocol(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _cache[45] || (_cache[45] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Jurnal Sasaran", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.target_journal) = $event)),
              placeholder: "Jurnal Nasional Sinta 2 / Scopus Q2"
            }, null, 512), [
              [_vModelText, _ctx.form.target_journal]
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _cache[46] || (_cache[46] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, [
              _createTextVNode("Bahasa Naskah "),
              _createElementVNode("span", { class: "text-danger" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.language) = $event)),
              required: "",
              placeholder: "Bahasa Indonesia / English"
            }, null, 512), [
              [_vModelText, _ctx.form.language]
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _cache[48] || (_cache[48] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, [
              _createTextVNode("Level Parafrase "),
              _createElementVNode("span", { class: "text-danger" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.paraphrase_level) = $event)),
              required: ""
            }, _cache[47] || (_cache[47] = [
              _createElementVNode("option", { value: "Level 1 - Penyuntingan ringan" }, "Level 1 - Penyuntingan ringan", -1),
              _createElementVNode("option", { value: "Level 2 - Parafrase kalimat" }, "Level 2 - Parafrase kalimat", -1),
              _createElementVNode("option", { value: "Level 3 - Rekonstruksi akademik" }, "Level 3 - Rekonstruksi akademik", -1),
              _createElementVNode("option", { value: "Level 4 - QC substantif bahasa" }, "Level 4 - QC substantif bahasa", -1)
            ]), 512), [
              [_vModelSelect, _ctx.form.paraphrase_level]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _cache[60] || (_cache[60] = _createElementVNode("div", { class: "d-flex align-items-center justify-content-between mb-3" }, [
            _createElementVNode("div", { class: "fw-bold fs-13 text-dark" }, "Matriks 4 Aspek Grammarly Pro & Editorial Manusia"),
            _createElementVNode("span", { class: "badge bg-secondary-subtle text-secondary fs-11 d-inline-flex align-items-center gap-1" }, [
              _createElementVNode("span", { class: "material-symbols-outlined fs-13" }, "edit_note"),
              _createElementVNode("span", null, "Poin Isu Aspek & Total Skor Diinput Manual")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("table", _hoisted_32, [
              _cache[59] || (_cache[59] = _createElementVNode("thead", { class: "table-light" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { style: {"width":"32%"} }, "Aspek Kualitas Bahasa"),
                  _createElementVNode("th", { style: {"width":"19%","text-align":"center"} }, "Poin Sebelum (Bisa > 100)"),
                  _createElementVNode("th", { style: {"width":"19%","text-align":"center"} }, "Poin Sesudah"),
                  _createElementVNode("th", { style: {"width":"30%"} }, "Status Aspek")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[50] || (_cache[50] = _createElementVNode("td", null, [
                    _createElementVNode("strong", null, "1. Correctness (Tata Bahasa)")
                  ], -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control form-control-sm text-center",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.correctness_before) = $event)),
                      min: "0",
                      placeholder: "e.g. 183"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.form.correctness_before,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control form-control-sm text-center",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.correctness_after) = $event)),
                      min: "0",
                      placeholder: "e.g. 0"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.form.correctness_after,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-sm",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.correctness_status) = $event))
                    }, _cache[49] || (_cache[49] = [
                      _createElementVNode("option", { value: "Selesai" }, "Selesai", -1),
                      _createElementVNode("option", { value: "Review" }, "Review", -1)
                    ]), 512), [
                      [_vModelSelect, _ctx.form.correctness_status]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[52] || (_cache[52] = _createElementVNode("td", null, [
                    _createElementVNode("strong", null, "2. Clarity (Kejelasan Kalimat)")
                  ], -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control form-control-sm text-center",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.clarity_before) = $event)),
                      min: "0",
                      placeholder: "e.g. 82"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.form.clarity_before,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control form-control-sm text-center",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.clarity_after) = $event)),
                      min: "0",
                      placeholder: "e.g. 0"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.form.clarity_after,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-sm",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.clarity_status) = $event))
                    }, _cache[51] || (_cache[51] = [
                      _createElementVNode("option", { value: "Selesai" }, "Selesai", -1),
                      _createElementVNode("option", { value: "Review" }, "Review", -1)
                    ]), 512), [
                      [_vModelSelect, _ctx.form.clarity_status]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[54] || (_cache[54] = _createElementVNode("td", null, [
                    _createElementVNode("strong", null, "3. Engagement (Kosakata Ilmiah)")
                  ], -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control form-control-sm text-center",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.engagement_before) = $event)),
                      min: "0",
                      placeholder: "e.g. 0"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.form.engagement_before,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control form-control-sm text-center",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.engagement_after) = $event)),
                      min: "0",
                      placeholder: "e.g. 0"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.form.engagement_after,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-sm",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.engagement_status) = $event))
                    }, _cache[53] || (_cache[53] = [
                      _createElementVNode("option", { value: "Selesai" }, "Selesai", -1),
                      _createElementVNode("option", { value: "Review" }, "Review", -1)
                    ]), 512), [
                      [_vModelSelect, _ctx.form.engagement_status]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[56] || (_cache[56] = _createElementVNode("td", null, [
                    _createElementVNode("strong", null, "4. Delivery (Nada Akademik)")
                  ], -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control form-control-sm text-center",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.delivery_before) = $event)),
                      min: "0",
                      placeholder: "e.g. 1"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.form.delivery_before,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control form-control-sm text-center",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.delivery_after) = $event)),
                      min: "0",
                      placeholder: "e.g. 0"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.form.delivery_after,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-sm",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.delivery_status) = $event))
                    }, _cache[55] || (_cache[55] = [
                      _createElementVNode("option", { value: "Selesai" }, "Selesai", -1),
                      _createElementVNode("option", { value: "Review" }, "Review", -1)
                    ]), 512), [
                      [_vModelSelect, _ctx.form.delivery_status]
                    ])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_33, [
                  _cache[57] || (_cache[57] = _createElementVNode("td", null, [
                    _createElementVNode("div", { class: "d-flex align-items-center gap-1" }, [
                      _createElementVNode("strong", null, "Total Grammarly Score (/100)"),
                      _createElementVNode("span", { class: "badge bg-secondary-subtle text-secondary fs-11" }, "Manual")
                    ]),
                    _createElementVNode("span", { class: "text-muted fs-11" }, "Input skor keseluruhan dari Grammarly Report (0-100)")
                  ], -1)),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control form-control-sm text-center fw-semibold",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.score_before) = $event)),
                      min: "0",
                      max: "100",
                      placeholder: "e.g. 57",
                      title: "Input skor keseluruhan awal Grammarly (0-100)"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.form.score_before,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control form-control-sm text-center fw-bold text-success",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.score_after) = $event)),
                      min: "0",
                      max: "100",
                      placeholder: "e.g. 96",
                      title: "Input skor keseluruhan akhir Grammarly (0-100)"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.form.score_after,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _cache[58] || (_cache[58] = _createElementVNode("td", { class: "text-center text-success fw-bold" }, "Skor Keseluruhan (/100)", -1))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _cache[67] || (_cache[67] = _createElementVNode("div", { class: "fw-bold fs-13 mb-2 text-dark" }, "Checklist Preservasi Substansi (6 Parameter Integritas)", -1)),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.preserve_numbers) = $event)),
                  id: "pNum"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.preserve_numbers]
                ]),
                _cache[61] || (_cache[61] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "pNum"
                }, "Preservasi Angka & Data", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.preserve_citations) = $event)),
                  id: "pCit"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.preserve_citations]
                ]),
                _cache[62] || (_cache[62] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "pCit"
                }, "Preservasi Sitasi & Referensi", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.preserve_technical_terms) = $event)),
                  id: "pTerm"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.preserve_technical_terms]
                ]),
                _cache[63] || (_cache[63] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "pTerm"
                }, "Preservasi Istilah Teknis", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.preserve_methods) = $event)),
                  id: "pMeth"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.preserve_methods]
                ]),
                _cache[64] || (_cache[64] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "pMeth"
                }, "Preservasi Metodologi", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.preserve_results) = $event)),
                  id: "pRes"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.preserve_results]
                ]),
                _cache[65] || (_cache[65] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "pRes"
                }, "Preservasi Temuan Utama", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.preserve_meaning) = $event)),
                  id: "pMean"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.preserve_meaning]
                ]),
                _cache[66] || (_cache[66] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "pMean"
                }, "Preservasi Makna/Argumen", -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _cache[68] || (_cache[68] = _createElementVNode("div", { class: "fw-bold fs-13 text-dark" }, "Log Saran Grammarly yang Ditolak (Human Expert Override)", -1)),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.addRejectedLog && _ctx.addRejectedLog(...args))),
              class: "btn btn-xs btn-outline-primary btn-sm fs-11"
            }, " + Tambah Log Penolakan ")
          ]),
          (_ctx.form.rejected_logs.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, _cache[69] || (_cache[69] = [
                _createTextVNode(" Belum ada log saran penolakan (Default kosong). Klik tombol "),
                _createElementVNode("strong", null, "\"+ Tambah Log Penolakan\"", -1),
                _createTextVNode(" jika ada saran Grammarly yang ditolak oleh editor. ")
              ])))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.rejected_logs, (log, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: "row g-2 mb-2 p-2 bg-white rounded border align-items-center"
            }, [
              _createElementVNode("div", _hoisted_51, [
                _cache[70] || (_cache[70] = _createElementVNode("label", { class: "form-label fs-11 text-muted mb-1 d-block" }, "Saran Grammarly", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm fs-12",
                  "onUpdate:modelValue": ($event: any) => ((log.original_suggestion) = $event),
                  onInput: ($event: any) => (log.suggestion_excerpt = log.original_suggestion),
                  placeholder: "Saran otomatis..."
                }, null, 40, _hoisted_52), [
                  [_vModelText, log.original_suggestion]
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _cache[72] || (_cache[72] = _createElementVNode("label", { class: "form-label fs-11 text-muted mb-1 d-block" }, "Aspek", -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm fs-12",
                  "onUpdate:modelValue": ($event: any) => ((log.aspect) = $event)
                }, _cache[71] || (_cache[71] = [
                  _createElementVNode("option", { value: "Correctness" }, "Correctness", -1),
                  _createElementVNode("option", { value: "Clarity" }, "Clarity", -1),
                  _createElementVNode("option", { value: "Engagement" }, "Engagement", -1),
                  _createElementVNode("option", { value: "Delivery" }, "Delivery", -1)
                ]), 8, _hoisted_54), [
                  [_vModelSelect, log.aspect]
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _cache[74] || (_cache[74] = _createElementVNode("label", { class: "form-label fs-11 text-muted mb-1 d-block" }, "Alasan Penolakan", -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-sm fs-12",
                  "onUpdate:modelValue": ($event: any) => ((log.reason_code) = $event),
                  onChange: ($event: any) => (log.rejection_code = log.reason_code)
                }, _cache[73] || (_cache[73] = [
                  _createStaticVNode("<option value=\"TECH_TERM\">TECH_TERM (Istilah Teknis)</option><option value=\"MEANING_RISK\">MEANING_RISK (Risiko Makna)</option><option value=\"CITATION_STYLE\">CITATION_STYLE (Sitasi)</option><option value=\"DIRECT_QUOTE\">DIRECT_QUOTE (Kutipan)</option><option value=\"JOURNAL_STYLE\">JOURNAL_STYLE (Gaya Jurnal)</option><option value=\"FALSE_POSITIVE\">FALSE_POSITIVE (Deteksi Keliru)</option>", 6)
                ]), 40, _hoisted_56), [
                  [_vModelSelect, log.reason_code]
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _cache[75] || (_cache[75] = _createElementVNode("label", { class: "form-label fs-11 text-muted mb-1 d-block" }, "Justifikasi Editor", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm fs-12",
                  "onUpdate:modelValue": ($event: any) => ((log.editor_justification) = $event),
                  onInput: ($event: any) => (log.rejection_reason = log.editor_justification),
                  placeholder: "Justifikasi penolakan..."
                }, null, 40, _hoisted_58), [
                  [_vModelText, log.editor_justification]
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: ($event: any) => (_ctx.removeRejectedLog(idx)),
                  class: "btn btn-link text-danger p-0",
                  title: "Hapus baris"
                }, _cache[76] || (_cache[76] = [
                  _createElementVNode("span", { class: "material-symbols-outlined fs-18" }, "delete", -1)
                ]), 8, _hoisted_60)
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _cache[77] || (_cache[77] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, [
              _createTextVNode("Nama Pengguna / Penulis (Tampil di Protokol & PDF) "),
              _createElementVNode("span", { class: "text-danger" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.author_name_masked) = $event)),
              required: "",
              placeholder: "Nama pengguna / penulis"
            }, null, 512), [
              [_vModelText, _ctx.form.author_name_masked]
            ])
          ]),
          _createElementVNode("div", _hoisted_63, [
            _cache[78] || (_cache[78] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, [
              _createTextVNode("Judul Dokumen / Naskah (Tampil di Protokol & PDF) "),
              _createElementVNode("span", { class: "text-danger" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.document_title_masked) = $event)),
              required: "",
              placeholder: "Judul dokumen / naskah"
            }, null, 512), [
              [_vModelText, _ctx.form.document_title_masked]
            ])
          ]),
          _createElementVNode("div", _hoisted_64, [
            _cache[79] || (_cache[79] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "Institusi / Afiliasi", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.institution) = $event)),
              placeholder: "Universitas ..."
            }, null, 512), [
              [_vModelText, _ctx.form.institution]
            ])
          ]),
          _createElementVNode("div", _hoisted_65, [
            _cache[81] || (_cache[81] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, [
              _createTextVNode("Status Keputusan QC "),
              _createElementVNode("span", { class: "text-danger" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.status_decision) = $event)),
              required: ""
            }, _cache[80] || (_cache[80] = [
              _createElementVNode("option", { value: "PASS / Memenuhi" }, "PASS / Memenuhi", -1),
              _createElementVNode("option", { value: "REVISE / Perlu Revisi" }, "REVISE / Perlu Revisi", -1),
              _createElementVNode("option", { value: "CLARIFY / Perlu Klarifikasi" }, "CLARIFY / Perlu Klarifikasi", -1),
              _createElementVNode("option", { value: "ESCALATE / Eskalasi QC" }, "ESCALATE / Eskalasi QC", -1)
            ]), 512), [
              [_vModelSelect, _ctx.form.status_decision]
            ])
          ]),
          _createElementVNode("div", _hoisted_66, [
            _cache[82] || (_cache[82] = _createElementVNode("label", { class: "form-label fs-13 fw-semibold" }, "SHA-256 Hash Naskah", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm font-monospace",
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.file_hash_sha256) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.form.file_hash_sha256]
            ])
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _cache[89] || (_cache[89] = _createElementVNode("h6", { class: "fs-13 fw-bold text-dark mb-2 d-flex align-items-center gap-1" }, [
                _createElementVNode("span", { class: "material-symbols-outlined fs-18 text-primary" }, "draw"),
                _createElementVNode("span", null, "Editor & Penandatangan Pengesahan Protokol")
              ], -1)),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _cache[83] || (_cache[83] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold" }, [
                    _createTextVNode("Nama Editor Bahasa "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.editor_name) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.form.editor_name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _cache[85] || (_cache[85] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold" }, "Pilih Penandatangan Terdaftar", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select form-select-sm",
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.signatory_id) = $event)),
                    onChange: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.onSignatoryChange && _ctx.onSignatoryChange(...args)))
                  }, [
                    _cache[84] || (_cache[84] = _createElementVNode("option", { value: null }, "-- Gunakan Penandatangan Default --", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signatories, (sig) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: sig.id,
                        value: sig.id
                      }, _toDisplayString(sig.name) + " (" + _toDisplayString(sig.position) + ") " + _toDisplayString(sig.is_default ? '★ Default' : ''), 9, _hoisted_72))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.form.signatory_id]
                  ])
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _cache[86] || (_cache[86] = _createElementVNode("label", { class: "form-label fs-12 fw-semibold" }, "Nama & Jabatan Pengesahan", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm mb-1",
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.signatory_name) = $event)),
                    placeholder: "Nama penandatangan"
                  }, null, 512), [
                    [_vModelText, _ctx.form.signatory_name]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.signatory_position) = $event)),
                    placeholder: "Jabatan penandatangan"
                  }, null, 512), [
                    [_vModelText, _ctx.form.signatory_position]
                  ])
                ]),
                (_ctx.selectedSignatoryPreviewUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _cache[87] || (_cache[87] = _createElementVNode("span", { class: "fs-11 text-muted fw-semibold" }, "Preview Tanda Tangan:", -1)),
                        _createElementVNode("img", {
                          src: _ctx.selectedSignatoryPreviewUrl,
                          alt: "Tanda Tangan",
                          style: {"height":"32px","max-width":"120px","object-fit":"contain"}
                        }, null, 8, _hoisted_76),
                        _cache[88] || (_cache[88] = _createElementVNode("span", { class: "fs-11 text-success d-flex align-items-center gap-1" }, [
                          _createElementVNode("span", { class: "material-symbols-outlined fs-14" }, "check_circle"),
                          _createElementVNode("span", null, "Siap disematkan pada sertifikat protokol")
                        ], -1))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_77, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary px-4 py-2 d-flex align-items-center gap-2",
            disabled: _ctx.submitting
          }, [
            (_ctx.submitting)
              ? (_openBlock(), _createElementBlock("span", _hoisted_79))
              : _createCommentVNode("", true),
            _cache[90] || (_cache[90] = _createElementVNode("span", { class: "material-symbols-outlined fs-18" }, "save", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.protocol ? 'Perbarui Protokol' : 'Simpan & Terbitkan Protokol RC-GRM'), 1)
          ], 8, _hoisted_78)
        ])
      ], 32)
    ])
  ]))
}